import React from "react";
import {
  FormControlLabel,
  FormGroup,
  Checkbox as MuiCheckbox,
  FormHelperText,
} from "@mui/material";

export default function InputCheck(props) {
  const {
    label,
    checked,
    defaultChecked,
    name,
    onChange,
    size = "medium",
    error = null,
    className,
    ...other
  } = props;
  return (
    <FormGroup sx={{ display: "contents", bgcolor: "red" }}>
      <FormControlLabel
        sx={{
          width: "fit-content",
          "& .MuiFormControlLabel-label": {
            userSelect: "none",
          },
        }}
        className={"checkbox-primary " + className}
        name={name}
        onChange={onChange}
        control={
          <MuiCheckbox
            size={size}
            checked={checked}
            defaultChecked={defaultChecked}
            className="p-5"
          />
        }
        label={label}
        {...other}
      />
      {error && (
        <FormHelperText className="color-danger">{error}</FormHelperText>
      )}
    </FormGroup>
  );
}
